/**
 * isooper = iso + contador de al menos 2 cifras: AAPL01, AAPL102, US3001, JP22510000.
 * El iso puede acabar en cifras (US30, JP225) y el contador no tiene longitud fija, así que
 * solo se puede separar conociendo el iso (mismo criterio que IsooperUtil en el backend).
 */
export function contadorIsooper(isooper: string | null | undefined, iso: string | null | undefined): number | null {
  if (!isooper || !iso || !isooper.startsWith(iso)) return null;
  const resto = isooper.substring(iso.length);
  return /^\d{1,9}$/.test(resto) ? Number(resto) : null;
}

/** iso + contador con al menos 2 cifras, sin recortar: AAPL01, AAPL100. */
export function formarIsooper(iso: string, contador: number): string {
  return iso + String(contador).padStart(2, '0');
}

/**
 * Iso del isooper: el `iso` conocido si el isooper empieza por él; si no se conoce, se quitan
 * las 2 últimas cifras (válido mientras el contador no pase de 99).
 */
export function isoDeIsooper(isooper: string, iso?: string | null): string {
  return contadorIsooper(isooper, iso) !== null ? iso! : isooper.replace(/\d{2}$/, '');
}
